import { http, httpFile } from './http_service';

//Get all
export function all(){
    return http().get('/dashboard-admin/all');
}
export function thisMonth(obj){
    return http().post('/dashboard-admin/this-month', obj);
}

export function lastMonth(obj){
    return http().post('/dashboard-admin/last-month', obj);
}

export function lastYear(obj){
    return http().post('/dashboard-admin/last-year', obj);
}

export function allQuoteStatus(obj){
    return http().post('/dashboard-admin/all-quote-status', obj);
}

export function allLeadsStatus(obj){
  return http().post('/dashboard-admin/all-leads-status', obj);
}

export function thisMonthLeads(obj){
  return http().post('/dashboard-admin/this-month-leads', obj);
}

export function lastMonthLeads(obj){
  return http().post('/dashboard-admin/last-month-leads', obj);
}

export function lastYearLeads(obj){
  return http().post('/dashboard-admin/last-year-leads', obj);
}


